var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":"","x-small":"","to":{ name: 'rewards' },"color":"var(--v-secondary-base)"}},[_c('img',{attrs:{"src":require("@/assets/views/crown_rewards_white.svg"),"height":16}})])
}
var staticRenderFns = []

export { render, staticRenderFns }